"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DropdownItemApplyButton = _interopRequireDefault(require("./DropdownItemApplyButton"));
var _DropdownItemCheckbox = _interopRequireDefault(require("./DropdownItemCheckbox"));
var _DropdownItemDefault = _interopRequireDefault(require("./DropdownItemDefault"));
var _Dropdown = _interopRequireDefault(require("react-bootstrap/Dropdown"));
var _DropdownItemMenu = _interopRequireDefault(require("./DropdownItemMenu"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DropdownItemToggle = _interopRequireDefault(require("./DropdownItemToggle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A Dropdown component can be a simple replacement for an HTML <select> element
 * or it can have additional features and capabilities, like radio or checkbox
 * form controls.
 */
const Dropdown = allProps => {
  const {
    children,
    type,
    ...props
  } = allProps;
  const classes = type === 'checkbox' ? 'dropdown--custom-control' : '';
  return /*#__PURE__*/_react.default.createElement(_Dropdown.default, _extends({
    className: classes
  }, props), children);
};
Dropdown.propTypes = {
  /** The type of dropdown. This controls the appearance of the dropdown. */
  type: _propTypes.default.oneOf(['default', 'checkbox'])
};
Dropdown.ApplyButton = _DropdownItemApplyButton.default;
Dropdown.CheckboxItem = _DropdownItemCheckbox.default;
Dropdown.DefaultItem = _DropdownItemDefault.default;
Dropdown.Divider = _Dropdown.default.Divider;
Dropdown.Menu = _DropdownItemMenu.default;
Dropdown.Toggle = _DropdownItemToggle.default;
Dropdown.defaultProps = {
  type: 'default'
};
var _default = exports.default = Dropdown;